export default function carPageTabs() {

    const carPageTabs = document.querySelectorAll('.js-car-page-tab');

    if ( carPageTabs.length ) {
        for (let tab of carPageTabs ) {
            tab.addEventListener('click',function(){
               document.querySelector('.car-page__tab_active')?.classList.remove('car-page__tab_active'); 
               tab.classList.add('car-page__tab_active'); 
               let id = tab.dataset.carPageTab;

               document.querySelector(`.car-page__box_show`)?.classList.remove("car-page__box_show");
               document.querySelector(`.car-page__box[data-car-page-tab='${id}'`)?.classList.add("car-page__box_show");

                

            });
        }
    }

}